import { render, staticRenderFns } from "./TcoOroProductBlock.vue?vue&type=template&id=ca000116"
import script from "./TcoOroProductBlock.vue?vue&type=script&lang=js"
export * from "./TcoOroProductBlock.vue?vue&type=script&lang=js"
import style0 from "./TcoOroProductBlock.vue?vue&type=style&index=0&id=ca000116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports